import { render, staticRenderFns } from "./calendarAFSRequest.vue?vue&type=template&id=60827844&scoped=true"
import script from "./calendarAFSRequest.vue?vue&type=script&lang=js"
export * from "./calendarAFSRequest.vue?vue&type=script&lang=js"
import style0 from "./calendarAFSRequest.vue?vue&type=style&index=0&id=60827844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60827844",
  null
  
)

export default component.exports